import {
  AssignmentTypeOption,
  Condition,
} from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import {
  ConditionType,
  ConditionTypeDetailsProps,
} from "../../return-flow/condition";

export type AssignmentTypeState = Omit<Condition.AssignmentType, "type">;

export const ASSIGNMENT_TYPE = (
  Details: React.ComponentType<ConditionTypeDetailsProps<AssignmentTypeState>>,
): ConditionType<AssignmentTypeState, Condition.AssignmentType> => ({
  name: "Assignment",
  description(state) {
    return state.assignmentType;
  },
  Details(props: ConditionTypeDetailsProps<AssignmentTypeState>) {
    return React.createElement(Details, props);
  },
  empty: { assignmentType: AssignmentTypeOption.NO_ASSIGNEE },
  fromModel(model) {
    return { assignmentType: model.assignmentType };
  },
  toModel(state) {
    return { type: Condition.ASSIGNMENT_TYPE, ...state };
  },
  valid(state) {
    return !!state.assignmentType;
  },
});
